<div [formGroup]="parentForm">
	<table
		mat-table
		class="ob-table ob-table-plain no-link-decoration"
		aria-label="table"
		matSort
		[dataSource]="dataSource"
		[formArrayName]="controlName"
	>
		<ng-container [matColumnDef]="COLUMN_ACTIONS">
			<th mat-header-cell *matHeaderCellDef>
				<div class="action-wrapper">
					<div class="action-button">
						<button
							id="{{ controlName + '-add-row' }}"
							obButton="secondary"
							mat-icon-button
							(click)="onAddRow()"
							[disabled]="!canAdd()"
							matTooltip="{{ 'i18n.tooltip.addrow' | translate }}"
							type="button"
						>
							<mat-icon svgIcon="plus" class="ob-icon"></mat-icon>
						</button>
					</div>
				</div>
			</th>
			<td mat-cell *matCellDef="let row; let i = index">
				<div class="action-wrapper">
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="{{ controlName + '-discard-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onDiscard()"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.discard' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="xmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (isRowEditMode(i)) {
						<div class="action-button">
							<button
								id="{{ controlName + '-save-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="save()"
								[disabled]="!canSave(i)"
								matTooltip="{{ 'i18n.tooltip.save' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="checkmark" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (canEdit()) {
						<div class="action-button">
							<button
								id="{{ controlName + '-edit-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onEditRow(i)"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.tooltip.edit' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="pencil" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
					@if (canRemove()) {
						<div class="action-button">
							<button
								id="{{ controlName + '-remove-row' + i }}"
								obButton="secondary"
								mat-icon-button
								(click)="onRemoveRow(i)"
								[disabled]="hasSelectedRows()"
								matTooltip="{{ 'i18n.button.remove.tooltip' | translate }}"
								type="button"
							>
								<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
							</button>
						</div>
					}
				</div>
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_HAD_ROLE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.had_role" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_HAD_ROLE">
				@if (isRowEditMode(i)) {
					<mat-form-field>
						<mat-label>{{ "i18n.property.had_role" | translate }}</mat-label>
						<mat-select
							id="{{ controlName + '-select-hadRole' + i }}"
							formControlName="hadRole"
							(selectionChange)="type(element, $event.value, COLUMN_HAD_ROLE)"
							[compareWith]="compareType"
						>
							@for (item of relationshipRole$ | async; track item; let ii = $index) {
								<mat-option [value]="item" (onSelectionChange)="type(element, item, COLUMN_HAD_ROLE)" id="{{ controlName + '-option-hadRole' + ii }}">
									{{ item?.name | fallback: currentLanguage }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				} @else {
					<span>{{ element.hadRole.name | fallback: currentLanguage }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_URI">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.url" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_URI">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field>
							<input
								id="{{ controlName + '-href' + i }}"
								formControlName="uri"
								matInput
								(keyup)="type(element.relation, $event.target.value, COLUMN_URI)"
								[value]="element.relation?.uri"
								required
							/>
							<mat-icon matIconSuffix matTooltip="{{ 'i18n.help_format_url' | translate }}" svgIcon="question_circle" class="ob-icon help-icon"></mat-icon>
						</mat-form-field>
					</div>
				} @else {
					<span [ngClass]="{ 'invalid-span': isControlInvalid(i) }">{{ element.relation?.uri }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_GERMAN">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.title_de" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_GERMAN">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field formGroupName="label">
							<input
								id="{{ controlName + '-de' + i }}"
								formControlName="de"
								matInput
								(keyup)="type(element.relation?.label, $event.target.value, COLUMN_GERMAN)"
								[value]="element.relation?.label?.de"
							/>
						</mat-form-field>
					</div>
				} @else {
					<span>{{ element.relation?.label?.de }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_FRENCH">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.title_fr" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_FRENCH">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field formGroupName="label">
							<input
								id="{{ controlName + '-fr' + i }}"
								formControlName="fr"
								matInput
								(keyup)="type(element.relation?.label, $event.target.value, COLUMN_FRENCH)"
								[value]="element.relation?.label?.fr"
							/>
						</mat-form-field>
					</div>
				} @else {
					<span>{{ element.relation?.label?.fr }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_ITALIAN">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.title_it" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_ITALIAN">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field formGroupName="label">
							<input
								id="{{ controlName + '-it' + i }}"
								formControlName="it"
								matInput
								(keyup)="type(element.relation?.label, $event.target.value, COLUMN_ITALIAN)"
								[value]="element.relation?.label?.it"
							/>
						</mat-form-field>
					</div>
				} @else {
					<span>{{ element.relation?.label?.it }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_ENGLISH">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.title_en" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_ENGLISH">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field formGroupName="label">
							<input
								id="{{ controlName + '-en' + i }}"
								formControlName="en"
								matInput
								(keyup)="type(element.relation?.label, $event.target.value, COLUMN_ENGLISH)"
								[value]="element.relation?.label?.en"
							/>
						</mat-form-field>
					</div>
				} @else {
					<span>{{ element.relation?.label?.en }}</span>
				}
			</td>
		</ng-container>

		<ng-container [matColumnDef]="COLUMN_ROMANCH">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ "i18n.property.title_rm" | translate }}
			</th>
			<td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" [title]="COLUMN_ROMANCH">
				@if (isRowEditMode(i)) {
					<div formGroupName="relation">
						<mat-form-field formGroupName="label">
							<input
								id="{{ controlName + '-rm' + i }}"
								formControlName="rm"
								matInput
								(keyup)="type(element.relation?.label, $event.target.value, COLUMN_ROMANCH)"
								[value]="element.relation?.label?.rm"
							/>
						</mat-form-field>
					</div>
				} @else {
					<span>{{ element.relation?.label?.rm }}</span>
				}
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns"></tr>
	</table>

	<div class="table-info-box">
		<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
	</div>
</div>
